<div class="row">
  <div class="col-12">
    <!-- title -->
    <magieno-input-text-field [advancedFormControl]="this.title"
                              type="string"></magieno-input-text-field>

    <magieno-select [advancedFormControl]="this.propertyType"></magieno-select>

    @if (this.areSharesVisible) {
      <div
        class="card">
        <div class="card-body">
          <magieno-boolean-select
                  [advancedFormControl]="this.areShares"></magieno-boolean-select>
        </div>
      </div>
    }

    @if (this.isBusinessIncomeVisible) {
      <div
        class="card">
        <div class="card-body">
          <magieno-boolean-select
                  [advancedFormControl]="this.isBusinessIncome"></magieno-boolean-select>
        </div>
      </div>
    }

    <magieno-boolean-select
            [advancedFormControl]="this.isDoPerfectRollover"></magieno-boolean-select>

    <magieno-input-money-field [advancedFormControl]="this.adjustedCostBase"
      [currency]="this.currency"
                               [locale]="this.locale"></magieno-input-money-field>

    <magieno-input-money-field [advancedFormControl]="this.fairMarketValue"
      [currency]="this.currency"
                               [locale]="this.locale"></magieno-input-money-field>
    @if (propertyForm.value.isDoPerfectRollover === false) {
      <magieno-input-money-field
              [advancedFormControl]="this.agreedAmount"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
    }

    <h4 class="mt-5">Actions</h4>
    <div class="card ">
      <div class="card-body pb-5" style="position: relative;">

        @if (isSectionSharesApplicable === false) {
          <div class="alert alert-light" role="alert">
            <i class="fas fa-exclamation-triangle"></i> Cette section ne s'applique pas. Cette section est
            seulement pour un bien non-amortissable qui est une action.
          </div>
        }

        <div class="text-center" style="position: absolute; bottom: 10px; width: 100%;">
          <button (click)="collapseSectionSharesApplicable.toggle()"
            class="shadow btn btn-link btn-outline-light rounded-pill"
            style="">
            @if (isSectionSharesCollapsed) {
              <span><i class="fas fa-angle-double-down"></i> Agrandir</span>
            }
            @if (!isSectionSharesCollapsed) {
              <span><i class="fas fa-angle-double-up"></i> Réduire</span>
            }
          </button>
        </div>

        <div #collapseSectionSharesApplicable="ngbCollapse" [(ngbCollapse)]="isSectionSharesCollapsed"
          class="row">
          <div class="col-12">

            <magieno-input-money-field [advancedFormControl]="this.paidUpCapitalOfTransferredShares"
              [currency]="this.currency"
                                       [locale]="this.locale"></magieno-input-money-field>

            <magieno-boolean-select
                    [advancedFormControl]="this.isInternalRollOver"></magieno-boolean-select>

            <magieno-boolean-select
                    [advancedFormControl]="this.isSameSharesConditions"></magieno-boolean-select>


            <!--Section 84.1-->
            <app-rollover-property-section-84_1-form #section841
            [form]="this.section84_1"></app-rollover-property-section-84_1-form>
          </div>
        </div>
      </div>
    </div>

    <h3 id="bien-ammortissable">Bien ammortissable</h3>
    <div class="card ">
      <div class="card-body pb-5" style="position: relative;">

        @if (isSectionDepreciablePropertyApplicable === false) {
          <div class="alert alert-light" role="alert">
            <i class="fas fa-exclamation-triangle"></i> Cette section ne s'applique pas. Cette section est
            seulement pour un bien amortissable.
          </div>
        }

        <div class="text-center" style="position: absolute; bottom: 10px; width: 100%;">
          <button (click)="collapseSectionDepreciablePropertyApplicable.toggle()"
            class="shadow btn btn-link btn-outline-light rounded-pill"
            style="">
            @if (isSectionDepreciablePropertyCollapsed) {
              <span><i class="fas fa-angle-double-down"></i> Agrandir</span>
            }
            @if (!isSectionDepreciablePropertyCollapsed) {
              <span><i class="fas fa-angle-double-up"></i> Réduire</span>
            }
          </button>
        </div>

        <div #collapseSectionDepreciablePropertyApplicable="ngbCollapse"
          [(ngbCollapse)]="isSectionDepreciablePropertyCollapsed"
          class="row">
          <div class="col-12">

            <magieno-input-money-field
                    [advancedFormControl]="this.underpreciatedCapitalCostAfterAdditionsAndDispositions"
              [currency]="this.currency"
                    [locale]="this.locale"></magieno-input-money-field>

            <magieno-boolean-select
                    [advancedFormControl]="this.isDepreciablePropertyTheLastOfItsCategory"></magieno-boolean-select>

            <magieno-select [advancedFormControl]="this.propertyRevenueType"></magieno-select>

          </div>
        </div>
      </div>
    </div>

    <h4 class="mt-5">Admissibilité du bien au choix du roulement</h4>
    <magieno-boolean-select
            [advancedFormControl]="this.isVerifyPropertyEligibility"></magieno-boolean-select>
    @if (this.propertyForm.value.isVerifyPropertyEligibility === true) {
      <div
        class="card">
        <div class="card-body">
          <magieno-boolean-select
                  [advancedFormControl]="this.isRealEstate"></magieno-boolean-select>
          @if (this.propertyForm.value.isRealEstate === true && this.propertyForm.value.propertyType !== rolloverPropertyTypeEnum.inventoryProperty) {
            <div
              class="card">
              <div class="card-body">
                <magieno-boolean-select
                        [advancedFormControl]="this.isNonResident"></magieno-boolean-select>
              </div>
            </div>
          }
          <div class="card">
            <div class="card-body">
              <magieno-boolean-select
                      [advancedFormControl]="this.isCustomerAccount"></magieno-boolean-select>
              <magieno-boolean-select
                      [advancedFormControl]="this.isArticle22"></magieno-boolean-select>
              <magieno-boolean-select
                      [advancedFormControl]="this.isCashAccounting"></magieno-boolean-select>
            </div>
          </div>
          @if (isErrorNotAdmissibleProperty === true) {
            <div class="alert alert-danger" role="alert">
              <i class="fas fa-exclamation-triangle"></i> Le bien n'est pas un bien admissible.
            </div>
          }
        </div>
      </div>
    }

    <app-rollover-property-non-share-consideration-form [form]="this.form" [propertyForm]="propertyForm"
    [propertyTransferredIndex]="index"></app-rollover-property-non-share-consideration-form>

    <app-rollover-property-share-classes-form [form]="this.form" [propertyForm]="propertyForm"
    [propertyTransferredIndex]="index"></app-rollover-property-share-classes-form>

  </div>
</div> <!-- / .row -->